export default "attribute vec3 position;\n\nvoid main() {\n\tgl_Position = vec4( position, 1.0 );\n}";